export default "__VITE_ASSET__DdSZUzYN__"